import { NgModule } from '@angular/core';
import { IsIncludedPipe } from './is-included.pipe';

@NgModule({
    declarations: [IsIncludedPipe],
    exports: [IsIncludedPipe],
})
export class IsIncludedPipeModule {}
